import { render, staticRenderFns } from "./KabDeiyai.vue?vue&type=template&id=66f16d46"
import script from "./KabDeiyai.vue?vue&type=script&lang=js"
export * from "./KabDeiyai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports